export default __webpack_public_path__ + "static/media/longchamp15.769952cc.jpg";